"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isNumeric(n) {
    if (typeof n === 'number') {
        return true;
    }
    return !isNaN(parseFloat(n)) && isFinite(n);
}
exports.isNumeric = isNumeric;
function padLeft(paddingValue, value) {
    return (paddingValue + value.toString()).slice(-paddingValue.length);
}
exports.padLeft = padLeft;
//# sourceMappingURL=numeric.js.map